import ContentsTypes from "@shared/enums/contentsTypes";
import TabsPreview from "@project/components/TabsComponent/TabsComponentPreview";
export const TabsComponent = {
    label: "Onglets",
    type: ContentsTypes.TABS_COMPONENT,
    Preview: TabsPreview,
    icon: "th-list",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Direction",
            key: "direction",
            type: ContentsTypes.RADIO_GROUP,
            value: "horizontal",
            options: [
                { label: "Horizontal", value: "horizontal" },
                { label: "Vertical", value: "vertical" },
            ],
        },
        {
            label: "Style",
            key: "style",
            type: ContentsTypes.RADIO_GROUP,
            value: "text",
            options: [
                { label: "Texte", value: "text" },
                { label: "Contenu", value: "contained" },
            ],
        },
        {
            label: "Couleur",
            key: "color",
            type: ContentsTypes.RADIO_GROUP,
            value: "primary",
            options: [
                { label: "Primaire", value: "primary" },
                { label: "Secondaire", value: "secondary" },
            ],
        },
        {
            label: "Onglets",
            key: "tabs",
            type: ContentsTypes.TABS,
            value: "",
        },
    ],
};
